import { Box } from "@mui/material";
import React from "react";
import type {
  ComponentNode,
  IconComponentProps,
  InjectedData,
} from "../layout-types";
import { resolveStyles } from "../layout-types";
import { resolveMuiIconComponent } from "../../components/MuiIconResolver";

interface LayoutIconProps {
  node: ComponentNode;
  data: InjectedData;
}

const LayoutIcon: React.FC<LayoutIconProps> = ({ node, data }) => {
  const props = (node.props ?? {}) as IconComponentProps;
  const resolved = resolveStyles(node.style, data);
  const Icon = resolveMuiIconComponent(props.iconName ?? "Star");

  if (resolved.visibility === false) {
    return null;
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color:
          props.color ?? (resolved.color as string | undefined) ?? "#111111",
        opacity: resolved.opacity as number | undefined,
        boxSizing: "border-box",
      }}
    >
      {Icon ? (
        <Icon
          sx={{
            fontSize: props.size ?? Math.min(node.width, node.height),
            color: "inherit",
          }}
        />
      ) : null}
    </Box>
  );
};

export default LayoutIcon;
